export interface IPPF_FORMULA {
  yearly: number;
  monthly: number;
  halfYearly: number;
  quarterly: number;
  investmentDuration: number;
  rateOfInterest: number;
  investmentFrequency: FREQUENCY;
}
export enum FREQUENCY {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  HALF_YEARLY = 'halfYearly',
  YEARLY = 'yearly',
}

export const PPF_FORMULA = ({
  yearly,
  monthly,
  halfYearly,
  quarterly,
  investmentDuration,
  rateOfInterest,
  investmentFrequency,
}: IPPF_FORMULA) => {
  const noOfInstallmentInAYear = Number(INSTALLMENTS[investmentFrequency]);
  const selectedInstallmentAmount = getSelectedInstallment(
    investmentFrequency,
    monthly,
    yearly,
    halfYearly,
    quarterly
  );
  const yearlyAmount = selectedInstallmentAmount * noOfInstallmentInAYear;
  const interest = Number(rateOfInterest) / 100;

  if (investmentDuration === 0 || isNaN(interest)) {
    return { maturityAmount: 0 };
  }
  const maturityAmount =
    yearlyAmount *
    ((Math.pow(1 + interest, investmentDuration) - 1) / interest) *
    (1 + interest);

  return { maturityAmount };
};

export const getSelectedInstallment = (
  investmentFrequency: string,
  monthly: number,
  yearly: number,
  halfYearly: number,
  quarterly: number
) => {
  if (investmentFrequency === 'monthly') return monthly;
  else if (investmentFrequency === 'quarterly') return quarterly;
  else if (investmentFrequency === 'halfYearly') return halfYearly;
  else return yearly;
};

export const INSTALLMENTS = {
  monthly: 12,
  quarterly: 4,
  halfYearly: 2,
  yearly: 1,
};
